/**
 * Reviews — fetches from the ZALT reviews API and renders
 * both the infinite slider and full review list with stats.
 */
(function () {
  'use strict';

  var STAR_SVG = '<svg viewBox="0 0 20 20" fill="currentColor"><path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z"/></svg>';

  function renderStars(rating, size) {
    var html = '';
    for (var i = 0; i < 5; i++) {
      var cls = i < rating ? 'review-card__star review-card__star--filled' : 'review-card__star review-card__star--empty';
      html += '<span class="' + cls + '" style="width:' + size + 'px;height:' + size + 'px;display:inline-block;">' + STAR_SVG + '</span>';
    }
    return html;
  }

  function buildSliderCard(review, cardBg) {
    var rating = parseInt(review.stars) || 5;
    var initial = (review.customer_name || '?').charAt(0).toUpperCase();
    return '<div class="review-card" style="background-color:' + cardBg + ';">' +
      '<p class="review-card__text font-peridot">' + escapeHtml(review.review) + '</p>' +
      '<div class="review-card__footer">' +
        '<div class="review-card__author">' +
          '<div class="review-card__avatar">' + initial + '</div>' +
          '<span class="review-card__name font-peridot">' + escapeHtml(review.customer_name) + '</span>' +
        '</div>' +
        '<div class="review-card__stars">' + renderStars(rating, 16) + '</div>' +
      '</div>' +
    '</div>';
  }

  function buildReviewCard(review) {
    var rating = parseInt(review.stars) || 5;
    var initial = (review.customer_name || '?').charAt(0).toUpperCase();
    var html = '<div style="padding-bottom:1rem;margin-bottom:1rem;border-bottom:1px solid #E5E5E5;">' +
      '<div style="display:flex;align-items:flex-start;gap:0.75rem;">' +
        '<div style="width:2rem;height:2rem;border-radius:9999px;background:#192B3F;color:#fff;display:flex;align-items:center;justify-content:center;font-size:0.875rem;font-weight:600;flex-shrink:0;">' + initial + '</div>' +
        '<div style="flex:1;">' +
          '<div style="display:flex;flex-wrap:wrap;align-items:center;gap:0.5rem;margin-bottom:0.25rem;">' +
            '<span class="font-peridot" style="font-weight:600;font-size:0.875rem;color:#192B3F;">' + escapeHtml(review.customer_name) + '</span>' +
            '<div style="display:flex;">' + renderStars(rating, 12) + '</div>' +
          '</div>' +
          '<p class="font-peridot" style="font-size:0.875rem;line-height:1.6;color:#192B3F;opacity:0.85;">' + escapeHtml(review.review) + '</p>';

    if (review.admin_reply) {
      html += '<div style="margin-top:0.75rem;padding-left:0.75rem;padding:0.5rem 0.75rem;border-left:2px solid #192B3F;background:#f8f9fa;">' +
        '<span class="font-peridot" style="font-size:0.75rem;font-weight:600;color:#192B3F;">' + escapeHtml(review.admin_reply.replied_by || 'ZALT Team') + '</span>' +
        '<p class="font-peridot" style="font-size:0.875rem;color:#192B3F;opacity:0.85;margin-top:0.25rem;">' + escapeHtml(review.admin_reply.reply_text) + '</p>' +
      '</div>';
    }

    html += '</div></div></div>';
    return html;
  }

  function buildStats(data) {
    var avg = (data.averageRating || 0).toFixed(1);
    var total = data.totalCount || 0;
    var dist = data.distribution || {};
    var html = '<div style="display:flex;align-items:flex-start;gap:1.5rem;">' +
        '<div>' +
          '<div class="font-roca" style="font-size:2.5rem;font-weight:700;color:#192B3F;line-height:1;">' + avg + '</div>' +
          '<div style="display:flex;margin:0.25rem 0;">' + renderStars(Math.round(data.averageRating || 0), 16) + '</div>' +
          '<div class="font-peridot" style="font-size:0.75rem;color:#192B3F;opacity:0.6;">' + total + ' reviews</div>' +
        '</div>' +
        '<div style="min-width:150px;max-width:200px;">';

    for (var r = 5; r >= 1; r--) {
      var count = dist[r] || 0;
      var pct = total > 0 ? (count / total) * 100 : 0;
      html += '<div style="display:flex;align-items:center;gap:0.5rem;margin-bottom:0.25rem;">' +
        '<span class="font-peridot" style="font-size:0.75rem;font-weight:500;color:#192B3F;width:10px;">' + r + '</span>' +
        '<div style="flex:1;height:6px;background:#E5E7EB;border-radius:9999px;overflow:hidden;">' +
          '<div style="height:100%;background:#192B3F;border-radius:9999px;width:' + pct + '%;' + (pct > 0 ? 'min-width:2px;' : '') + '"></div>' +
        '</div>' +
      '</div>';
    }

    html += '</div></div>';
    return html;
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ========================
     Infinite Review Slider
     ======================== */
  function initSlider() {
    var el = document.querySelector('[data-review-slider]');
    if (!el) return;

    var apiUrl = el.getAttribute('data-api-url');
    var productId = el.getAttribute('data-product-id');
    var cardBg = el.getAttribute('data-card-bg') || '#FFFFFF';
    var loadingEl = el.querySelector('[data-review-slider-loading]');
    var trackEl = el.querySelector('[data-review-slider-track]');

    fetch(apiUrl + '/api/reviews/product/' + productId + '?page=1&limit=20')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var reviews = data.reviews || [];
        if (reviews.length === 0) {
          el.style.display = 'none';
          return;
        }

        var cardsHtml = '';
        reviews.forEach(function (review) {
          cardsHtml += buildSliderCard(review, cardBg);
        });

        // Duplicate for seamless loop
        trackEl.innerHTML = cardsHtml + cardsHtml;

        // Calculate scroll duration based on card count
        var cardWidth = window.innerWidth >= 768 ? 350 : 300;
        var totalWidth = reviews.length * (cardWidth + 16);
        var duration = Math.max(totalWidth / 50, 20);
        trackEl.style.setProperty('--review-scroll-duration', duration + 's');

        if (loadingEl) loadingEl.style.display = 'none';
        trackEl.style.display = 'flex';
      })
      .catch(function (err) {
        console.error('Failed to load review slider:', err);
        el.style.display = 'none';
      });
  }

  /* ========================
     Full Review List
     ======================== */
  function initReviewList() {
    var el = document.querySelector('[data-review-list]');
    if (!el) return;

    var apiUrl = el.getAttribute('data-api-url');
    var productId = el.getAttribute('data-product-id');
    var statsEl = el.querySelector('[data-review-stats]');
    var countEl = el.querySelector('[data-review-count]');
    var cardsEl = el.querySelector('[data-review-cards]');
    var loadingEl = el.querySelector('[data-review-loading]');
    var loadMoreWrap = el.querySelector('[data-review-load-more]');
    var loadMoreBtn = el.querySelector('[data-review-load-more-btn]');
    var formToggle = el.querySelector('[data-review-form-toggle]');
    var formContainer = el.querySelector('[data-review-form-container]');
    var form = el.querySelector('[data-review-form]');
    var starInput = el.querySelector('[data-review-star-input]');
    var successEl = el.querySelector('[data-review-form-success]');

    var currentPage = 1;
    var hasMore = false;
    var selectedRating = 5;

    // Star input for form
    if (starInput) {
      renderStarInput(selectedRating);
      starInput.addEventListener('click', function (e) {
        var star = e.target.closest('[data-star]');
        if (star) {
          selectedRating = parseInt(star.getAttribute('data-star'));
          renderStarInput(selectedRating);
        }
      });
    }

    function renderStarInput(rating) {
      var html = '';
      for (var i = 1; i <= 5; i++) {
        var color = i <= rating ? '#FB923C' : '#D1D5DB';
        html += '<span data-star="' + i + '" style="cursor:pointer;width:24px;height:24px;display:inline-block;color:' + color + ';">' + STAR_SVG + '</span>';
      }
      starInput.innerHTML = html;
    }

    // Form toggle
    if (formToggle) {
      formToggle.addEventListener('click', function () {
        var isVisible = formContainer.style.display !== 'none';
        formContainer.style.display = isVisible ? 'none' : 'block';
      });
    }

    // Form submit
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var nameInput = form.querySelector('[name="customerName"]');
        var textInput = form.querySelector('[name="reviewText"]');
        var submitBtn = el.querySelector('[data-review-submit]');

        if (!nameInput.value.trim() || !textInput.value.trim()) return;

        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';

        fetch(apiUrl + '/api/reviews/submit', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            productId: productId,
            customerName: nameInput.value.trim(),
            rating: selectedRating,
            reviewText: textInput.value.trim()
          })
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            if (data.success) {
              form.style.display = 'none';
              successEl.style.display = 'block';
              setTimeout(function () {
                formContainer.style.display = 'none';
                form.style.display = 'block';
                successEl.style.display = 'none';
                form.reset();
                selectedRating = 5;
                renderStarInput(5);
                submitBtn.disabled = false;
                submitBtn.textContent = 'Submit Review';
              }, 3000);
            }
          })
          .catch(function () {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Submit Review';
          });
      });
    }

    // Load reviews
    function loadReviews(page) {
      fetch(apiUrl + '/api/reviews/product/' + productId + '?page=' + page + '&limit=10')
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (loadingEl) loadingEl.style.display = 'none';

          // Stats (only on first load)
          if (page === 1 && statsEl) {
            statsEl.innerHTML = buildStats(data);
            if (countEl) {
              countEl.innerHTML = '<span class="font-peridot" style="font-size:0.875rem;color:#192B3F;opacity:0.6;">' + (data.totalCount || 0) + ' reviews</span>';
            }
          }

          // Cards
          var reviews = data.reviews || [];
          reviews.forEach(function (review) {
            cardsEl.insertAdjacentHTML('beforeend', buildReviewCard(review));
          });

          // Pagination
          hasMore = data.pagination && data.pagination.hasMore;
          if (hasMore) {
            loadMoreWrap.style.display = 'block';
          } else {
            loadMoreWrap.style.display = 'none';
          }
        })
        .catch(function (err) {
          console.error('Failed to load reviews:', err);
          if (loadingEl) loadingEl.innerHTML = '<p class="font-peridot" style="color:var(--color-gray-500);">Unable to load reviews.</p>';
        });
    }

    // Load more button
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        currentPage++;
        loadReviews(currentPage);
      });
    }

    // Initial load
    loadReviews(1);
  }

  /* ========================
     Lazy init
     ========================
     Reviews are below the fold on the PDP. Don't kick off api.tryzalt.com
     fetches on first paint — they compete with LCP and add ~200ms of
     server-response time on the critical path. Instead, set up an
     IntersectionObserver that fires the init when the element is within
     ~1 viewport of becoming visible.

     If IntersectionObserver isn't available, fall back to immediate init.
  */
  function lazyInit(selector, init) {
    var el = document.querySelector(selector);
    if (!el) return;

    if (typeof IntersectionObserver !== 'function') {
      init();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      if (entries.some(function (e) { return e.isIntersecting; })) {
        io.disconnect();
        init();
      }
    }, { rootMargin: '150% 0px 150% 0px' });
    io.observe(el);
  }

  function start() {
    lazyInit('[data-review-slider]', initSlider);
    lazyInit('[data-review-list]', initReviewList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
